export * from "./lib/shared-ui-histogram-filter.module";
export * from "./lib/histogram-filter/histogram-filter.types";
